export var VersionEvent;
(function (VersionEvent) {
    VersionEvent["Create"] = "create";
    VersionEvent["Update"] = "update";
    VersionEvent["MarkedAsResolved"] = "marked_as_resolved";
    VersionEvent["MarkedAsUnresolved"] = "marked_as_unresolved";
    // Legacy DeficiencyHistory statuses. `Created` is the history row's own status, distinct
    // from paper_trail's `create`, though both read as "created".
    VersionEvent["Created"] = "created";
    VersionEvent["AddedToInspection"] = "added_to_inspection";
    VersionEvent["AddedToProposal"] = "added_to_proposal";
    VersionEvent["LinkedToProposal"] = "linked_to_proposal";
})(VersionEvent || (VersionEvent = {}));
